import { Flex, Image, Text } from '@chakra-ui/react';
import { LogoType } from 'src/features/MP/types';
import { useNavigate } from 'react-router-dom';
import logoWhite from 'src/assets/images/logo/logo_white.svg';
import logoBlack from 'src/assets/images/logo/logo_black.svg';

export const YapamarLogo: React.FC<LogoType> = ({
  theme = 'white',
  clickable = true,
}) => {
  const navigate = useNavigate();
  return (
    <Flex
      align="center"
      cursor={clickable ? 'pointer' : 'default'}
      onClick={clickable ? () => navigate('/') : undefined}>
      <Image
        src={theme === 'dark' ? logoBlack : logoWhite}
        alt="Yapamar logo"
        h={5}
        w="auto"
        mr={2}
      />

      <Text
        // fontWeight="bold"
        fontWeight="medium"
        fontSize="1em"
        lineHeight="1"
        color={theme === 'dark' ? 'text.darkBlue.900' : 'text.lightGrey'}
        fontFamily="marketingPage">
        YAPAMAR
      </Text>
    </Flex>
  );
};
